export const updateDatiPianoSpostamentoAutomatico = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};
